import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  dialog: {
    maxWidth: 700,
    margin: 'auto',
    maxHeight: 600,
    borderRadius: 0,
    position: 'relative',
    backgroundColor: '#000',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 500,
      maxHeight: 600,
    },
  },
  content: {
    backgroundColor: '#000',
    padding: 24,
  },
  title: {
    margin: '50px 0 40px 0',
    letterSpacing: '2px',
    textAlign: 'center',
    fontWeight: 650,
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.5rem',
      fontWeight: 450,
    },
  },
  subtitle: {
    fontSize: '0.9rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8rem',
    },
  },

  clickLink: {
    marginTop: '30px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.6rem',
    },
  },
  enterButton: {
    margin: '20px 0 50px 0',
    fontSize: '1.4rem',
    fontWeight: 380,
    letterSpacing: '3px',
    textTransform: 'uppercase',
    textDecoration: 'none',
    color: '#fff',
    '&:hover': {
      background: 'linear-gradient(90deg, #92fe9d 0%, #00C9FF 100%)',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1rem',
      fontWeight: 350,
    },
  },
}))
